import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router";
import { FaPen, FaUser, FaTasks } from 'react-icons/fa';
import { 
    HiSparkles, HiTrophy, HiFire, HiEnvelope, HiChatBubbleLeftRight, 
    HiHandThumbUp, HiUsers, HiCalendar 
} from 'react-icons/hi2';
import { MdEmojiEvents, MdShare } from 'react-icons/md';
import moment from "moment";
import { motion, AnimatePresence } from "framer-motion";

import Avatar from "../../components/Avatar/Avatar";
import EditProfileForm from "./EditProfileForm";
import ProfileBio from "./ProfileBio";
import UserAchievements from "./UserAchievements";
import UserTasks from "./UserTasks";
import { fetchAllPosts } from '../../actions/post';
import { fetchAllUsers, fetchUserProfileById, toggleTask } from '../../actions/users';

import "./UsersProfile.css";

const UserProfile = () => {
    const { id } = useParams();
    const users = useSelector((state) => state.usersReducer);
    const postsList = useSelector((state) => state.postsReducer);
    const currentUser = useSelector((state) => state.currentUserReducer);



    let currentProfile = users.find((user) => user._id === id);

    const [Switch, setSwitch] = useState(false);
    const [activeTab, setActiveTab] = useState('profile');
    const [copiedReferral, setCopiedReferral] = useState(false);

    console.log("--- UserProfile Component Render ---");
    console.log("URL ID (id):", id);
    console.log("Logged-in User (currentUser):", currentUser);
    console.log("Logged-in User ID (currentUser?.result?._id):", currentUser?.result?._id);
    console.log("Current Profile Being Viewed (currentProfile):", currentProfile);
    console.log("Edit Button Condition (currentUser?.result?._id === id):", currentUser?.result?._id === id);
    console.log("Switch state for EditProfileForm:", Switch);
    console.log("------------------------------------");

    const dispatch = useDispatch();



    useEffect(() => {


        const userInStore = users.find(user => user._id === id);
        if (id && (!userInStore || !userInStore.xp)) {
            console.log(`[UserProfile useEffect 1] Fetching user profile for ID: ${id}`);
            dispatch(fetchUserProfileById(id));
        }


        if (users.length === 0) {
            console.log("[UserProfile useEffect 1] Fetching all users.");
            dispatch(fetchAllUsers());
        }


        if (!postsList.data || postsList.data.length === 0) {
            console.log("[UserProfile useEffect 1] Fetching all posts.");
            dispatch(fetchAllPosts());
        }



    }, [dispatch, id, users.length, postsList.data?.length]);





    useEffect(() => {



        if (currentUser?.result?._id === id) {
            console.log(`[UserProfile useEffect 2] Re-fetching logged-in user's profile (${id}) due to currentUser change.`);
            dispatch(fetchUserProfileById(id));
        }
    }, [currentUser?.result?._id, id, dispatch]);



    const handleTaskToggle = async (taskId) => {

        if (!currentUser?.result || currentUser.result._id !== currentProfile._id) {
            alert("You can only toggle your own tasks!");
            return;
        }
        await dispatch(toggleTask(currentUser.result._id, taskId));



        dispatch(fetchUserProfileById(id));
    };


    const copyReferralCode = () => {
        if (currentProfile?.referralCode) {
            navigator.clipboard.writeText(currentProfile.referralCode);
            setCopiedReferral(true);
            setTimeout(() => setCopiedReferral(false), 2000);
        }
    };


    if (!currentProfile) {
        return (
            <motion.div
                className="home-container-1 user-profile-page"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                <div className="home-container-2 user-profile-content">
                    <motion.h1
                        initial={{ y: -20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                    >
                        Loading profile...
                    </motion.h1>
                </div>
            </motion.div>
        );
    }

    return (
        <motion.div
            className="home-container-1 user-profile-page"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            <motion.div className="home-container-2 user-profile-content">
                <motion.section
                    className="profile-header-section"
                    initial={{ y: -30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <div className="user-details-container">
                        {currentProfile?.profilePicture ? (
                            <motion.img
                                src={currentProfile.profilePicture}
                                alt="User Logo"
                                className="user-profile-logo"
                                initial={{ scale: 0.9, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.4 }}
                                whileHover={{ scale: 1.05 }}
                            />
                        ) : (
                            <motion.div
                                initial={{ scale: 0.9, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.4 }}
                                whileHover={{ scale: 1.05 }}
                            >
                                <Avatar
                                    backgroundColor="#00BFFF"
                                    borderRadius="50%"
                                    color="black"
                                    fontSize="60px"
                                    px="60px"
                                    py="40px"
                                >
                                    {currentProfile?.name.charAt(0).toUpperCase()}
                                </Avatar>
                            </motion.div>
                        )}

                        <motion.div
                            className="user-info-main"
                            initial={{ opacity: 0, x: 20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                        >
                            <motion.h1
                                className="user-display-name"
                                initial={{ opacity: 0, y: -10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.1, duration: 0.3 }}
                            >
                                {currentProfile?.name}
                            </motion.h1>
                            {currentProfile?.username && (
                                <motion.p
                                    className="user-username"
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: 0.2, duration: 0.3 }}
                                >
                                    @{currentProfile.username}
                                </motion.p>
                            )}
                            <motion.p
                                className="user-joined-date"
                                initial={{ opacity: 0, y: -10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.3, duration: 0.3 }}
                            >
                                <HiCalendar /> Joined{" "}
                                {moment(currentProfile?.joinedOn).fromNow()}
                            </motion.p>

                            {}
                            <div className="gamification-stats">
                                {/* XP Card - Full Width */}
                                <motion.div
                                    className="stat-card stat-xp stat-xp-with-progress"
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{ delay: 0.1, duration: 0.3 }}
                                >
                                        <div className="stat-icon-wrapper stat-icon-xp">
                                            <HiSparkles />
                                        </div>
                                        <div className="stat-content stat-content-xp">
                                            <div className="xp-header">
                                                <strong>{currentProfile?.xp || 0}</strong>
                                                <span>XP</span>
                                            </div>
                                            {(() => {
                                                const currentXP = currentProfile?.xp || 0;
                                                const currentLevel = currentProfile?.level || 1;
                                                let xpForCurrentLevel = 0;
                                                let xpForNextLevel = 0;
                                                
                                                if (currentLevel === 1) {
                                                    xpForCurrentLevel = 0;
                                                    xpForNextLevel = 1500;
                                                } else if (currentLevel === 2) {
                                                    xpForCurrentLevel = 1500;
                                                    xpForNextLevel = 3000;
                                                } else if (currentLevel === 3) {
                                                    xpForCurrentLevel = 3000;
                                                    xpForNextLevel = 5000;
                                                } else if (currentLevel === 4) {
                                                    xpForCurrentLevel = 5000;
                                                    xpForNextLevel = 10000;
                                                } else {
                                                    xpForCurrentLevel = 10000;
                                                    xpForNextLevel = 10000;
                                                }
                                                
                                                const xpInCurrentLevel = currentXP - xpForCurrentLevel;
                                                const xpNeededForNext = xpForNextLevel - xpForCurrentLevel;
                                                const progressPercentage = currentLevel >= 5 
                                                    ? 100 
                                                    : Math.min(100, (xpInCurrentLevel / xpNeededForNext) * 100);
                                                const xpRemaining = currentLevel >= 5 ? 0 : xpForNextLevel - currentXP;
                                                
                                                return (
                                                    <div className="xp-progress-container">
                                                        <div className="xp-progress-bar-wrapper">
                                                            <motion.div
                                                                className="xp-progress-bar"
                                                                initial={{ width: 0 }}
                                                                animate={{ width: `${progressPercentage}%` }}
                                                                transition={{ delay: 0.3, duration: 0.8, ease: "easeOut" }}
                                                            />
                                                        </div>
                                                        <div className="xp-progress-text">
                                                            {currentLevel >= 5 ? (
                                                                <span className="xp-max-level">Max Level! 🎉</span>
                                                            ) : (
                                                                <span className="xp-remaining">{xpRemaining} XP to Level {currentLevel + 1}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                </motion.div>
                                
                                {/* Primary Stats Row */}
                                <div className="stats-row stats-row-primary">
                                    <motion.div
                                        className="stat-card stat-level"
                                        initial={{ opacity: 0, scale: 0.9 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: 0.2, duration: 0.3 }}
                                    >
                                        <div className="stat-icon-wrapper stat-icon-level">
                                            <HiTrophy />
                                        </div>
                                        <div className="stat-content">
                                            <strong>{currentProfile?.level || 1}</strong>
                                            <span>Level</span>
                                        </div>
                                    </motion.div>
                                    
                                    <motion.div
                                        className="stat-card stat-rank"
                                        initial={{ opacity: 0, scale: 0.9 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: 0.3, duration: 0.3 }}
                                    >
                                        <div className="stat-icon-wrapper stat-icon-rank">
                                            <MdEmojiEvents />
                                        </div>
                                        <div className="stat-content">
                                            <strong>{currentProfile?.rank || 'Newbie'}</strong>
                                            <span>Rank</span>
                                        </div>
                                    </motion.div>
                                    
                                    <motion.div
                                        className="stat-card stat-streak"
                                        initial={{ opacity: 0, scale: 0.9 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: 0.4, duration: 0.3 }}
                                    >
                                        <div className="stat-icon-wrapper stat-icon-streak">
                                            <HiFire />
                                        </div>
                                        <div className="stat-content">
                                            <strong>{currentProfile?.loginStreak || 0}</strong>
                                            <span>Day Streak</span>
                                        </div>
                                    </motion.div>
                                </div>
                                
                                <div className="stats-row stats-row-secondary">
                                    <motion.div
                                        className="stat-card stat-posts"
                                        initial={{ opacity: 0, scale: 0.9 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: 0.5, duration: 0.3 }}
                                    >
                                        <div className="stat-icon-wrapper stat-icon-posts">
                                            <HiEnvelope />
                                        </div>
                                        <div className="stat-content">
                                            <strong>{currentProfile?.postsCount || 0}</strong>
                                            <span>Posts</span>
                                        </div>
                                    </motion.div>
                                    
                                    <motion.div
                                        className="stat-card stat-comments"
                                        initial={{ opacity: 0, scale: 0.9 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: 0.6, duration: 0.3 }}
                                    >
                                        <div className="stat-icon-wrapper stat-icon-comments">
                                            <HiChatBubbleLeftRight />
                                        </div>
                                        <div className="stat-content">
                                            <strong>{currentProfile?.commentsCount || 0}</strong>
                                            <span>Comments</span>
                                        </div>
                                    </motion.div>
                                    
                                    <motion.div
                                        className="stat-card stat-likes"
                                        initial={{ opacity: 0, scale: 0.9 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: 0.7, duration: 0.3 }}
                                    >
                                        <div className="stat-icon-wrapper stat-icon-likes">
                                            <HiHandThumbUp />
                                        </div>
                                        <div className="stat-content">
                                            <strong>{currentProfile?.likesGivenCount || 0}</strong>
                                            <span>Likes Given</span>
                                        </div>
                                    </motion.div>
                                </div>
                                
                                {currentProfile?.referredUsersCount !== undefined && currentProfile.referredUsersCount > 0 && (
                                    <div className="stats-row stats-row-referrals">
                                        <motion.div
                                            className="stat-card stat-referrals"
                                            initial={{ opacity: 0, scale: 0.9 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{ delay: 0.8, duration: 0.3 }}
                                        >
                                            <div className="stat-icon-wrapper stat-icon-referrals">
                                                <HiUsers />
                                            </div>
                                            <div className="stat-content">
                                                <strong>{currentProfile.referredUsersCount}</strong>
                                                <span>Referrals</span>
                                            </div>
                                        </motion.div>
                                    </div>
                                )}
                                {currentUser?.result?._id === id && currentProfile?.referralCode && (
                                    <div className="referral-code-wrapper">
                                        <motion.div
                                            className="stat-card stat-referral-code"
                                            initial={{ opacity: 0, scale: 0.9 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{ delay: 1.3, duration: 0.3 }}
                                        >
                                            <div className="stat-icon-wrapper stat-icon-referral-code">
                                                <MdShare />
                                            </div>
                                            <div className="stat-content stat-content-referral">
                                                <div className="referral-header">
                                                    <span className="referral-label">Your Referral Code</span>
                                                    <strong className="referral-code-value">{currentProfile.referralCode}</strong>
                                                </div>
                                                <button
                                                    onClick={copyReferralCode}
                                                    className="copy-referral-btn"
                                                    whileHover={{ scale: 1.05 }}
                                                    whileTap={{ scale: 0.95 }}
                                                    transition={{ duration: 0.1 }}
                                                >
                                                    {copiedReferral ? 'Copied!' : 'Copy Code'}
                                                </button>
                                            </div>
                                        </motion.div>
                                    </div>
                                )}
                            </div>
                            {}
                        </motion.div>
                    </div>

                    {}
                    {currentUser?.result?._id === id && (
                        <motion.button
                            whileHover={{ scale: 1.08, backgroundColor: "#0069d9" }}
                            whileTap={{ scale: 0.95 }}
                            transition={{ duration: 0.2 }}
                            type="button"
                            onClick={() => setSwitch(true)}
                            className="edit-profile-btn"
                        >
                            <FaPen /> Account Settings
                        </motion.button>
                    )}
                </motion.section>

                {}
                <motion.div
                    className="profile-tabs"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2, duration: 0.4 }}
                >
                    {[
                        { key: 'profile', icon: FaUser, label: 'Profile' },
                        { key: 'achievements', icon: HiTrophy, label: `Achievements (${currentProfile?.achievements?.length || 0})` },
                        { key: 'tasks', icon: FaTasks, label: `Daily Tasks (${currentProfile?.tasks?.filter(task => !task.completed).length || 0})` }
                    ].map(tab => {
                        const IconComponent = tab.icon;
                        return (
                            <motion.button
                                key={tab.key}
                                className={`profile-tab-btn ${activeTab === tab.key ? 'active' : ''}`}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.98 }}
                                transition={{ duration: 0.1 }}
                                onClick={() => setActiveTab(tab.key)}
                            >
                                <IconComponent /> <motion.span>{tab.label}</motion.span>
                            </motion.button>
                        );
                    })}
                </motion.div>

                {}
                <motion.div className="profile-tab-content">
                    <AnimatePresence mode="wait">
                        {Switch ? (
                            <motion.div
                                key="edit-form"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -20 }}
                                transition={{ duration: 0.3 }}
                            >
                                <EditProfileForm
                                    currentUser={currentUser}
                                    setSwitch={setSwitch}
                                    currentProfile={currentProfile}
                                />
                            </motion.div>
                        ) : activeTab === 'profile' ? (
                            <motion.div
                                key="bio"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -20 }}
                                transition={{ duration: 0.3 }}
                            >
                                <ProfileBio currentProfile={currentProfile} />
                            </motion.div>
                        ) : activeTab === 'achievements' ? (
                            <motion.div
                                key="achievements"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -20 }}
                                transition={{ duration: 0.3 }}
                            >
                                <UserAchievements achievements={currentProfile?.achievements || []} />
                            </motion.div>
                        ) : activeTab === 'tasks' ? (
                            <motion.div
                                key="tasks"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -20 }}
                                transition={{ duration: 0.3 }}
                            >
                                <UserTasks
                                    tasks={currentProfile?.tasks || []}
                                    userId={currentUser?.result?._id}
                                    onToggleTask={handleTaskToggle}
                                    isCurrentUserProfile={currentUser?.result?._id === id}
                                />
                            </motion.div>
                        ) : null}
                    </AnimatePresence>
                </motion.div>
            </motion.div>
        </motion.div>
    );
};

export default UserProfile;